module.exports = __webpack_public_path__ + "img/top-1-2.532c37be.jpg";